import { FormStepType } from "./types";
import { applicant_details } from "./steps/applicant-details";
import { contact_information } from "./steps/contact-information";
import { passport_details_lost_stolen } from "./steps/passport-details-lost-stolen";
import { lost_stolen_information } from "./steps/lost-stolen-information";
import { getParentsAndSpouseStep } from "./steps/parents-and-spouse";

export const form_ds_64: FormStepType[] = [
  applicant_details,
  contact_information({ additionalPhoneNumbers: 1 }),
  passport_details_lost_stolen,
  lost_stolen_information,
  getParentsAndSpouseStep({ id: 5 }),
];
